import store from "../../../../../store/store";

export const componentKey = 'MASTER_MEDICATION';

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMasterMedicationList: (state, action) => {
            state.masterMedicationData = action.payload;
        }, 
        setOpenAddMedicationModal: (state, action) => {
            state.isOpenAddMedicationModal = action.payload;
        }
    },
    initialReducerState: {
        masterMedicationData: [],
        isOpenAddMedicationModal: false,
    },
});

export const { setMasterMedicationList, setOpenAddMedicationModal } = actions;
